module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<section class=\"top\">\n<div class=\"headline\">\n<div class=\"message\">\n<%- model.headlineTop %>\n</div>\n<%\nif(model.headlineTopDescription){\n// TODO: translations\n%><%- include('../../../base/tooltip/tooltip', { model: {\n\"title\": \"Info\",\nmessage: model.headlineTopDescription,\n} }); %><%\n}\n%>\n</div>\n<%- helpers.renderSection('top', false) %>\n</section>\n<section class=\"bottom\">\n<div class=\"headline\">\n<div class=\"message\">\n<%- model.headlineBottom %>\n</div>\n<%\nif(model.headlineBottomDescription){\n// TODO: translations\n%><%- include('../../../base/tooltip/tooltip', { model: {\n\"title\": \"Info\",\nmessage: model.headlineBottomDescription,\n} }); %><%\n}\n%>\n</div>\n<%- helpers.renderSection('bottom', false) %>\n</section>\n</div>"
  , __filename = "components/templates/core/scheduler/filterController.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<section class=\"top\">\n<div class=\"headline\">\n<div class=\"message\">\n")
    ; __line = 5
    ; __append( model.headlineTop )
    ; __append("\n</div>\n")
    ; __line = 7
    ; 
if(model.headlineTopDescription){
// TODO: translations

    ; __line = 10
    ; __append( include('../../../base/tooltip/tooltip', { model: {
"title": "Info",
message: model.headlineTopDescription,
} }) )
    ; __line = 13
    ; 
}

    ; __line = 15
    ; __append("\n</div>\n")
    ; __line = 17
    ; __append( helpers.renderSection('top', false) )
    ; __append("\n</section>\n<section class=\"bottom\">\n<div class=\"headline\">\n<div class=\"message\">\n")
    ; __line = 22
    ; __append( model.headlineBottom )
    ; __append("\n</div>\n")
    ; __line = 24
    ; 
if(model.headlineBottomDescription){
// TODO: translations

    ; __line = 27
    ; __append( include('../../../base/tooltip/tooltip', { model: {
"title": "Info",
message: model.headlineBottomDescription,
} }) )
    ; __line = 30
    ; 
}

    ; __line = 32
    ; __append("\n</div>\n")
    ; __line = 34
    ; __append( helpers.renderSection('bottom', false) )
    ; __append("\n</section>\n</div>")
    ; __line = 36
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/scheduler/filterController.ejs

}